import ApiService from './ApiService';

class TradeBookService {
  async getTradeBook(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_trade_book', 'POST', payload);
      let data = response;

      return {
        orderList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getCancelBook(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_cancel_book', 'POST', payload);
      let data = response;

      return {
        orderList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async cancelOrder(payload) {
    try {
      const response = await ApiService.call('/secured/cancel_order', 'POST', payload);
      let data = response;

      return {
        cancellationStateType: data.cancellationStateType,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getOrderExecutionList(payload) {
    try {
      const response = await ApiService.call('/secured/get_order_execution_list', 'POST', payload);
      let data = response;

      console.log(data);

      return {
        orderExecutionDataList: data.orderExecutionDataList,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new TradeBookService();
